import { Eye, EyeOff } from 'lucide-react';
import { type ComponentProps, useState } from 'react';

import { cn } from '@/lib/utils';

// Password input with the show/hide eye affordance per Figma settings.html.
// The toggle button sits inside the input visually (absolute) and swaps
// the `type` attribute between `password` and `text`. Reveal state is
// local-only -- no global UI store, no persistence across fields, because
// every field re-hides on remount which is the safer default.
//
// Wraps the native input so RHF's `{...register}` flows through unchanged.
export function PasswordInput({
  className,
  type: _ignoredType,
  ref,
  ...props
}: ComponentProps<'input'>) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? Eye : EyeOff;

  return (
    <div className="relative">
      <input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={cn('sc-input text-xs leading-[18px] py-2.5 pe-10', className)}
        {...props}
      />
      <button
        type="button"
        aria-label={visible ? 'Hide password' : 'Show password'}
        onClick={() => setVisible((v) => !v)}
        className="absolute top-1/2 end-4 -translate-y-1/2 w-4 h-4 text-placeholder hover:text-gray30 transition-colors"
      >
        <Icon className="w-4 h-4" />
      </button>
    </div>
  );
}
